import z from 'zod';

export const encodedSignUpDataSchema = z.string().min(1).max(256);
